import {
  HttpClient,
  getCode3Widget,
  getAbAirport,
  getInterfaceError,
  uniteLogin,
  getRequestChannel,
  setResponseMsg,
  // enhanceRequest
} from '@csair/emp-helpers';
import { Toast } from 'antd-mobile';
import urlConfig from 'Url';
import { toQueryString } from 'Utils';
import { requestMergeCode, setResponseMsg2 } from 'setApiMessageObj';
import { setResponseMsg3 } from 'enEXchange';
import Routes from 'Routes';
import TicPopUp from 'TicPopUp';
import busy from '../components/BusyPopup';
import loginPop from '../components/LoginPopup';
import ProgressBar from 'ProgressBar';
import en from 'en';
let isEN = window.sessionStorage.getItem('language')
  ? window.sessionStorage.getItem('language') == 'en'
  : location.href.includes('language=en');
function isAxiosRequest(action) {
  return action.payload && action.payload.request;
}
function jumpPage() {
  const curl = window.location.href;
  if (curl.includes('refundTicket')) {
    window.location.href = urlConfig.fastRefundUrl;
  }
  // if (
  //   curl.includes('ticketChange') ||
  //   curl.includes('/ticket/selectDate') ||
  //   curl.includes('/ticket/TicketChange')
  // ) {
  //   window.errorProcess();
  //   window.location.href = urlConfig.fastChange;
  // }
  if (
    curl.includes('updateDetail') ||
    curl.includes('ticketChange') ||
    curl.includes('/ticket/selectDate') ||
    curl.includes('/ticket/TicketChange')
  ) {
    busy();
  }
}
function getParams(url) {
  let theRequest = {};
  if (url.indexOf('?') !== -1) {
    let str = url.split('?');
    if (str[1] === '') {
      return theRequest;
    }
    let strs = str[1].split('&');
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = decodeURIComponent(
        strs[i].split('=')[1]
      );
    }
  }
  return theRequest;
}

async function readConfig() {
  const response = await client.createHttp('post', urlConfig.getConfig, {
    data: {
      key: ['is_Easy_Login_Turn_On'],
    },
  });
  if (response.data.map['is_Easy_Login_Turn_On']) {
    window.location.href = `${
      urlConfig.common_query_easy_url
    }?redirect=${encodeURIComponent(
      urlConfig.pageInfoDto.homeUrl
    )}&channel=emp`;
    return false;
  }
  login();
}

export function login() {
  let url = '';
  // let query = JSON.parse(
  //   JSON.parse(sessionStorage.getItem('persist:emp')).updateDetail
  // ).urlQuery;
  let persist_emp = JSON.parse(sessionStorage.getItem('persist:emp'));
  let p = getParams(window.location.href);
  if (p.moreQuery) delete p.moreQuery;
  if (p.easyQuery) delete p.easyQuery;
  if (p.urlParams) delete p.urlParams;
  if (p.selectTabStyle) delete p.selectTabStyle;
  let query = persist_emp ? JSON.parse(persist_emp.updateDetail).urlQuery : p;
  if (
    window.location.hash.indexOf(Routes.ticket.child.reformProcess.path) !== -1
  ) {
    url = encodeURIComponent(
      `${urlConfig.app_url}ticketRefund/#${
        Routes.ticket.child.reformProcess.path
      }${window.location.hash.slice(window.location.hash.indexOf('?'))}`
    );
  } else if (
    window.location.hash.indexOf(Routes.ticket.child.wrongPurchase.path) !== -1
  ) {
    url = encodeURIComponent(
      `${urlConfig.app_url}ticketRefund/#${
        Routes.ticket.child.wrongPurchase.path
      }`
    );
  } else if (
    window.location.hash.indexOf(Routes.ticket.child.feeQuery.path) !== -1
  ) {
    url = encodeURIComponent(
      `${urlConfig.app_url}ticketRefund/#${
        Routes.ticket.child.feeQuery.childs.login.path
      }`
    );
  } else if (
    window.location.hash.indexOf(Routes.ticket.child.cancelLation.path) !== -1
  ) {
    url = encodeURIComponent(
      `${urlConfig.app_url}ticketRefund/#${
        Routes.ticket.child.cancelLation.path
      }`
    );
  } else {
    url = encodeURIComponent(
      `${urlConfig.app_url}ticketRefund/#${
        Routes.ticket.child.updateDetail.path
      }?${toQueryString(query)}`
    );
  }
  if (persist_emp) {
    let App = JSON.parse(persist_emp.App);
    App.userInfo.channel = null;
    persist_emp.App = JSON.stringify(App);
    sessionStorage.setItem('persist:emp', JSON.stringify(persist_emp));
  }
  if (
    window.__wxjs_environment &&
    window.__wxjs_environment === 'miniprogram'
    // &&
    // (query.channel == 'cuss' ||
    //   JSON.parse(persist_emp ? persist_emp.updateDetail : '{}')
    //     .faceCheckChannel)
  ) {
    // uniteLogin(
    //   `${urlConfig.login_url
    //   }personal_new/login/#/?t=forward&redirect=${url}&channel=ETM&loginFuncMannel=%E9%80%80%E7%A5%A8%E5%8D%95%E6%9F%A5%E8%AF%A2&sysId=ETM&loginMode=2&topBarRightCode=empty&coopAccount=`,
    //   function () {
    //     Toast.info('登录失效', 1);
    //   }
    // );
    wx.miniProgram.navigateTo({
      url: `/page/jump?action=login&loginNextUrl=${url}&loginNextUrlRefresh=1`,
    });
  } else {
    uniteLogin(
      `${
        urlConfig.login_url
      }personal_new/login/#/?t=forward&redirect=${url}&channel=ETM&loginFuncMannel=%E9%80%80%E7%A5%A8%E5%8D%95%E6%9F%A5%E8%AF%A2&sysId=ETM&loginMode=0&coopAccount=`,
      function() {
        Toast.info(isEN ? en.loginFail : '登录失效', 1);
      }
    );
  }
}

export const client = new HttpClient(
  {
    timeout: 0,
    responseType: 'json',
    headers: {
      'x-requested-with': 'XMLHttpRequest',
    },
  },
  {
    config: {
      channel: true,
      channelRoutes: [
        Routes.ticket.child.endorsedApply.path,
        Routes.ticket.child.refundApply.path,
        Routes.ticket.child.selectDate.path,
        Routes.ticket.child.ticketChange.path,
        Routes.ticket.child.applySubmit.path,
      ],
    },
    load: {
      loading() {
        Toast.loading(isEN ? en.load11 : '加载中', 0);
        if (document.getElementById('wrapper')) {
          document
            .getElementById('wrapper')
            .setAttribute('aria-hidden', 'true');
        }
      },
      ending() {
        Toast.hide();
        if (document.getElementById('wrapper')) {
          document
            .getElementById('wrapper')
            .setAttribute('aria-hidden', 'false');
        }
      },
    },
    request: {
      interceptors: [
        {
          interceptor(config) {
            // 异常测试，其它时候需要注释掉
            // config = enhanceRequest(config);
            if (config.url.indexOf(urlConfig.downloadFile) !== -1) {
              config['responseType'] = 'blob';
            }
            if (window.location.href.includes('certificationResults')) {
              Toast.hide();
              if (document.getElementById('wrapper')) {
                document
                  .getElementById('wrapper')
                  .setAttribute('aria-hidden', 'false');
              }
            }
            config.headers[
              'login-channel'
            ] = navigator.userAgent.toLowerCase().includes('toutiaomicroapp')
              ? 'd'
              : getRequestChannel(config._channel);
            return config;
          },
          error(error) {
            Toast.hide();
            if (document.getElementById('wrapper')) {
              document
                .getElementById('wrapper')
                .setAttribute('aria-hidden', 'false');
            }
            return error;
          },
        },
      ],
    },
    response: {
      interceptors: [
        {
          interceptor(response) {
            // 接口数据 三字码 根据CMC重置
            if (response.config.url.indexOf(urlConfig.downloadFile) !== -1) {
              console.log(response);
              return response.data;
            }
            if (
              response.config.url.indexOf(
                urlConfig.afterSaleChangeReqDetail
              ) !== -1 &&
              Array.isArray(response.data.segInfoList)
            ) {
              response.data.segInfoList.forEach(item => {
                const depCode3Obj = getCode3Widget(
                  item.depAirport,
                  false,
                  isEN ? 'en' : 'cn'
                );
                const arrCode3Obj = getCode3Widget(
                  item.arrAirport,
                  false,
                  isEN ? 'en' : 'cn'
                );
                const oldarrCode3Obj = getCode3Widget(
                  item.oldarrAirport,
                  false,
                  isEN ? 'en' : 'cn'
                );
                const olddepCode3Obj = getCode3Widget(
                  item.olddepAirport,
                  false,
                  isEN ? 'en' : 'cn'
                );
                // item.depAirportNameSimple = getAbAirport(depCode3Obj);
                // item.arrAirportNameSimple = getAbAirport(arrCode3Obj);
                item.depAirportNameSimple =
                  getAbAirport(depCode3Obj) ||
                  depCode3Obj.airportName ||
                  item.depairportname;
                item.arrAirportNameSimple =
                  getAbAirport(arrCode3Obj) ||
                  arrCode3Obj.airportName ||
                  item.arrairportname;
                item.olddepAirportNameSimple =
                  getAbAirport(olddepCode3Obj) ||
                  olddepCode3Obj.airportName ||
                  item.olddepairportname;
                item.oldarrAirportNameSimple =
                  getAbAirport(oldarrCode3Obj) ||
                  oldarrCode3Obj.airportName ||
                  item.oldarrairportname;
                item.departCityName = depCode3Obj.cityName;
                item.arriveCityName = arrCode3Obj.cityName;
                item.depairportname = depCode3Obj.airportName;
                item.arrairportname = arrCode3Obj.airportName;
                item.oldDepartCityName = olddepCode3Obj.cityName;
                item.oldArriveCityName = oldarrCode3Obj.cityName;
              });
            }
            if (
              response.config.url.indexOf(
                urlConfig.afterGetRefundOrderDetail
              ) !== -1 &&
              Array.isArray(response.data.segmentInfos)
            ) {
              response.data.segmentInfos.forEach(item => {
                const depCode3Obj = getCode3Widget(
                  item.depAirportCode,
                  false,
                  isEN ? 'en' : 'cn'
                );
                const arrCode3Obj = getCode3Widget(
                  item.arrAirportCode,
                  false,
                  isEN ? 'en' : 'cn'
                );
                item.depAirportNameSimple =
                  getAbAirport(depCode3Obj) ||
                  depCode3Obj.airportName ||
                  item.depAirport;
                item.arrAirportNameSimple =
                  getAbAirport(arrCode3Obj) ||
                  arrCode3Obj.airportName ||
                  item.arrAirport;
                item.depCity = depCode3Obj.cityName;
                item.arrCity = arrCode3Obj.cityName;
                item.depAirport = depCode3Obj.airportName;
                item.arrAirport = arrCode3Obj.airportName;
              });
            }
            if (
              (response.config.url.indexOf(urlConfig.getTicektList) !== -1 ||
                response.config.url.indexOf(urlConfig.getMoreTicektList) !==
                  -1 ||
                response.config.url.indexOf(urlConfig.getIntreatmentBack) !==
                  -1) &&
              Array.isArray(response.data.orderList)
            ) {
              response.data.orderList.forEach(item => {
                const arrCode3Obj = getCode3Widget(
                  item.arrAirport,
                  false,
                  isEN ? 'en' : 'cn'
                );
                const depCode3Obj = getCode3Widget(
                  item.depAirport,
                  false,
                  isEN ? 'en' : 'cn'
                );
                if (item.transitAirport) {
                  const transitCode3Obj = getCode3Widget(
                    item.transitAirport,
                    false,
                    isEN ? 'en' : 'cn'
                  );
                  item.transitCityName = transitCode3Obj.cityName;
                  item.transitAirportName = transitCode3Obj.airportName;
                }
                item.depCityName = depCode3Obj.cityName;
                item.arrCityName = arrCode3Obj.cityName;
                item.depAirportName = depCode3Obj.airportName;
                item.arrAirportName = arrCode3Obj.airportName;
              });
            }
            if (
              response.config.url.indexOf(urlConfig.checkOrderTicket) !== -1 &&
              response.data.ticketFlights
            ) {
              response.data.ticketFlights.flightList.forEach(item => {
                const depCode3Obj = getCode3Widget(
                  item.depAirport,
                  item.planeType,
                  isEN ? 'en' : 'cn'
                );
                const arrCode3Obj = getCode3Widget(
                  item.arrAirport,
                  item.planeType,
                  isEN ? 'en' : 'cn'
                );
                item.depAirportNameSimple = getAbAirport(depCode3Obj);
                item.arrAirportNameSimple = getAbAirport(arrCode3Obj);
                item.depCityName = depCode3Obj.cityName;
                item.arrCityName = arrCode3Obj.cityName;
                item.depAirportName = depCode3Obj.airportName;
                item.arrAirportName = arrCode3Obj.airportName;
                item.departMCT = {
                  gn_gn: item.departDDMCT,
                  gn_gj: item.departDIMCT,
                  gj_gj: item.departAIMCT,
                  gj_gn: item.departADMCT,
                };
                item.arriveMCT = {
                  gn_gn: item.arrivalDDMCT,
                  gn_gj: item.arrivalDIMCT,
                  gj_gj: item.arrivalAIMCT,
                  gj_gn: item.arrivalADMCT,
                };
              });
            }
            if (
              response.config.url.indexOf(
                urlConfig.changeReqNewFlightDetail
              ) !== -1 &&
              Array.isArray(response.data.list)
            ) {
              response.data.list.forEach(item => {
                const arrCode3Obj = getCode3Widget(
                  item.arriveAirport,
                  item.planeStyle,
                  isEN ? 'en' : 'cn'
                );
                const depCode3Obj = getCode3Widget(
                  item.departAirport,
                  item.planeStyle,
                  isEN ? 'en' : 'cn'
                );
                item.depAirportNameSimple = getAbAirport(depCode3Obj);
                item.arrAirportNameSimple = getAbAirport(arrCode3Obj);
                item.departCity = depCode3Obj.cityName;
                item.arriveCity = arrCode3Obj.cityName;
                item.departAirportName = depCode3Obj.airportName;
                item.arriveAirportName = arrCode3Obj.airportName;
                // 处理单段变中转多段数据
                if (item.flightItemList && item.flightItemList.length > 0) {
                  item.flightItemList.forEach(key => {
                    const arrCode3Obj = getCode3Widget(
                      key.arriveAirport,
                      item.planeStyle,
                      isEN ? 'en' : 'cn'
                    );
                    const depCode3Obj = getCode3Widget(
                      key.departAirport,
                      item.planeStyle,
                      isEN ? 'en' : 'cn'
                    );
                    key.depAirportNameSimple = getAbAirport(depCode3Obj);
                    key.arrAirportNameSimple = getAbAirport(arrCode3Obj);
                    key.departCity = depCode3Obj.cityName;
                    key.arriveCity = arrCode3Obj.cityName;
                    key.departAirportName = depCode3Obj.airportName;
                    key.arriveAirportName = arrCode3Obj.airportName;
                  });
                }
              });
              if (
                response.data.bayArea &&
                response.data.bayArea.segmentOptions
              ) {
                response.data.bayArea.segmentOptions.forEach(child => {
                  const arrCode = getCode3Widget(
                    child.arriveAirportCode,
                    false,
                    isEN ? 'en' : 'cn'
                  );
                  const depCode = getCode3Widget(
                    child.departAirportCode,
                    false,
                    isEN ? 'en' : 'cn'
                  );
                  child.text = `${depCode.airportNameSimple}-${
                    arrCode.airportNameSimple
                  }`;
                });
              }
            }

            // 系统异常，进入预约流程
            let err;
            if (Array.isArray(response.data)) {
              if (response.data[0])
                err = response.data[0].errorInfo || response.data[0].error;
            } else {
              err = response.data.errorInfo || response.data.error;
            }
            if (
              err &&
              getInterfaceError(err.errorCode) &&
              JSON.parse(
                JSON.parse(window.sessionStorage.getItem('persist:emp')).App
              )['sysConfig']['the_flag_fastchange']
            ) {
              jumpPage();
            }
            if (response.config.url.includes('getAreaCodeList')) {
              return response;
            }
            response.data = setResponseMsg(response.data);

            // GN: [ID1556600][2024-10-16]
            // if (window.sessionStorage.getItem('csSwitch') == 'Y') {
            //   let type = window.sessionStorage.getItem('scopeType');
            //   if (/(updateDetail)/.test(window.location.href)) {
            //     if (response.config.url.includes('moreQuery')) {
            //       requestMergeCode('moreQuery', [
            //         require('../utils/apiAppeaNewMessgae/moreQuery.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //     if (response.config.url.includes('checkOrderTicket')) {
            //       requestMergeCode('checkOrderTicket', [
            //         type
            //           ? type.includes('bg')
            //             ? require('../utils/apiAppeaNewMessgae/checkOrderTicket.change.json')
            //             : require('../utils/apiAppeaNewMessgae/checkOrderTicket.refund.json')
            //           : require('../utils/apiAppeaNewMessgae/checkOrderTicket.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }
            //   if (/(changeRefundExplain)/.test(window.location.href)) {
            //     if (response.config.url.includes('queryRefundChangeFee')) {
            //       requestMergeCode('queryRefundChangeFee', [
            //         require('../utils/apiAppeaNewMessgae/queryRefundChangeFee.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //     if (response.config.url.includes('checkOrderTicketTPWL')) {
            //       requestMergeCode('checkOrderTicketTPWL', [
            //         require('../utils/apiAppeaNewMessgae/checkOrderTicket.tpwl.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }
            //   if (/(cancelLation)/.test(window.location.href)) {
            //     if (response.config.url.includes('checkOrderTicketTPWL')) {
            //       requestMergeCode('checkOrderTicketTPWL', [
            //         require('../utils/apiAppeaNewMessgae/checkOrderTicket.tpwl.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }

            //   if (/(EndorsedApply)/.test(window.location.href)) {
            //     let selectStyle = '';
            //     if (/(ticketChange)/.test(window.location.href))
            //       selectStyle = 'change';
            //     if (/(refundTicket)/.test(window.location.href))
            //       selectStyle = 'refund';
            //     if (/(TPWL)/.test(window.location.href)) selectStyle = 'tpwl';
            //     if (response.config.url.includes('cancelCheckIn')) {
            //       requestMergeCode('cancelCheckIn', [
            //         require('../utils/apiAppeaNewMessgae/cancelCheckIn.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //     if (response.config.url.includes('checkFlightDate')) {
            //       requestMergeCode('checkFlightDate', [
            //         require('../utils/apiAppeaNewMessgae/checkFlightDate.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }

            //     if (response.config.url.includes('checkTicketFlight')) {
            //       if (selectStyle === 'refund') {
            //         requestMergeCode('checkTicketFlight', [
            //           require('../utils/apiAppeaNewMessgae/checkTicketFlight.refund.json'),
            //         ]);
            //       }
            //       if (selectStyle === 'change') {
            //         requestMergeCode('checkTicketFlight', [
            //           require('../utils/apiAppeaNewMessgae/checkTicketFlight.change.json'),
            //         ]);
            //       }
            //       if (selectStyle === 'tpwl') {
            //         requestMergeCode('checkTicketFlightTPWL', [
            //           require('../utils/apiAppeaNewMessgae/checkTicketFlight.tpwl.json'),
            //         ]);
            //       }
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }

            //     if (response.config.url.includes('checkOrderTicket')) {
            //       if (selectStyle === 'refund') {
            //         requestMergeCode('checkOrderTicket', [
            //           require('../utils/apiAppeaNewMessgae/checkOrderTicket.refund.json'),
            //         ]);
            //       }
            //       if (selectStyle === 'change') {
            //         requestMergeCode('checkOrderTicket', [
            //           require('../utils/apiAppeaNewMessgae/checkOrderTicket.change.json'),
            //         ]);
            //       }
            //       if (selectStyle === 'tpwl') {
            //         requestMergeCode('checkOrderTicketTPWL', [
            //           require('../utils/apiAppeaNewMessgae/checkOrderTicket.tpwl.json'),
            //         ]);
            //       }
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }

            //   if (/(refundApply)/.test(window.location.href)) {
            //     if (response.config.url.includes('afterSaleRefundApp')) {
            //       requestMergeCode('afterSaleRefundApp', [
            //         require('../utils/apiAppeaNewMessgae/createRefund.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //     if (response.config.url.includes('createRefundTa')) {
            //       requestMergeCode('createRefundTa', [
            //         require('../utils/apiAppeaNewMessgae/createRefundTa.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //     if (response.config.url.includes('submitFastRefundMultiple')) {
            //       requestMergeCode('submitFastRefundMultiple', [
            //         require('../utils/apiAppeaNewMessgae/submitFastRefundMultiple.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }
            //   if (/(selectDate)/.test(window.location.href)) {
            //     if (response.config.url.includes('checkFlightDate')) {
            //       requestMergeCode('checkFlightDate', [
            //         require('../utils/apiAppeaNewMessgae/checkFlightDate.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }
            //   if (/(TicketChange)/.test(window.location.href)) {
            //     if (response.config.url.includes('checkFlightDate')) {
            //       requestMergeCode('checkFlightDate', [
            //         require('../utils/apiAppeaNewMessgae/checkFlightDate.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //     if (
            //       response.config.url.includes(
            //         'afterSaleChangeReqNewFlightDetail'
            //       )
            //     ) {
            //       requestMergeCode('afterSaleChangeReqNewFlightDetail', [
            //         require('../utils/apiAppeaNewMessgae/afterSaleChangeReqNewFlightDetail.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }
            //   if (/(ApplySubmit)/.test(window.location.href)) {
            //     let apiname = '';
            //     if (response.config.url.includes('afterSaleChangeReqPayOK'))
            //       apiname = 'afterSaleChangeReqPayOK';
            //     if (response.config.url.includes('afterSaleVolChangeReqPayOK'))
            //       apiname = 'afterSaleVolChangeReqPayOK';
            //     if (response.config.url.includes('touchConfirmIntVol'))
            //       apiname = 'touchConfirmIntVol';
            //     if (
            //       /(afterSaleChangeReqPayOK)|(afterSaleVolChangeReqPayOK)|(touchConfirmIntVol)/.test(
            //         response.config.url
            //       )
            //     ) {
            //       requestMergeCode(apiname, [
            //         require('../utils/apiAppeaNewMessgae/change.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }
            // } else {
            //   let type = window.sessionStorage.getItem('scopeType');
            //   if (/(updateDetail)/.test(window.location.href)) {
            //     if (response.config.url.includes('checkOrderTicket')) {
            //       requestMergeCode('checkOrderTicket', [
            //         type
            //           ? type.includes('bg')
            //             ? require('../utils/apiAppeaOldMessgae/checkOrderTicket.change.json')
            //             : require('../utils/apiAppeaOldMessgae/checkOrderTicket.refund.json')
            //           : require('../utils/apiAppeaOldMessgae/checkOrderTicket.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }
            //   if (/(cancelLation)/.test(window.location.href)) {
            //     if (response.config.url.includes('checkOrderTicketTPWL')) {
            //       requestMergeCode('checkOrderTicketTPWL', [
            //         require('../utils/apiAppeaOldMessgae/checkOrderTicket.tpwl.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }

            //   if (/(EndorsedApply)/.test(window.location.href)) {
            //     let selectStyle = '';
            //     if (/(ticketChange)/.test(window.location.href))
            //       selectStyle = 'change';
            //     if (/(refundTicket)/.test(window.location.href))
            //       selectStyle = 'refund';
            //     if (/(TPWL)/.test(window.location.href)) selectStyle = 'tpwl';

            //     if (response.config.url.includes('checkTicketFlight')) {
            //       if (selectStyle === 'refund') {
            //         requestMergeCode('checkTicketFlight', [
            //           require('../utils/apiAppeaOldMessgae/checkTicketFlight.refund.json'),
            //         ]);
            //       }
            //       if (selectStyle === 'change') {
            //         requestMergeCode('checkTicketFlight', [
            //           require('../utils/apiAppeaOldMessgae/checkTicketFlight.change.json'),
            //         ]);
            //       }
            //       if (selectStyle === 'tpwl') {
            //         requestMergeCode('checkTicketFlightTPWL', [
            //           require('../utils/apiAppeaOldMessgae/checkTicketFlight.tpwl.json'),
            //         ]);
            //       }
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }

            //     if (response.config.url.includes('checkOrderTicket')) {
            //       if (selectStyle === 'refund') {
            //         requestMergeCode('checkOrderTicket', [
            //           require('../utils/apiAppeaOldMessgae/checkOrderTicket.refund.json'),
            //         ]);
            //       }
            //       if (selectStyle === 'change') {
            //         requestMergeCode('checkOrderTicket', [
            //           require('../utils/apiAppeaOldMessgae/checkOrderTicket.change.json'),
            //         ]);
            //       }
            //       if (selectStyle === 'tpwl') {
            //         requestMergeCode('checkOrderTicketTPWL', [
            //           require('../utils/apiAppeaOldMessgae/checkOrderTicket.tpwl.json'),
            //         ]);
            //       }
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }
            //   if (/(refundApply)/.test(window.location.href)) {
            //     if (response.config.url.includes('afterSaleRefundApp')) {
            //       requestMergeCode('afterSaleRefundApp', [
            //         require('../utils/apiAppeaOldMessgae/createRefund.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }

            //     if (response.config.url.includes('submitFastRefundMultiple')) {
            //       requestMergeCode('submitFastRefundMultiple', [
            //         require('../utils/apiAppeaOldMessgae/submitFastRefundMultiple.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }

            //   if (/(TicketChange)/.test(window.location.href)) {
            //     if (
            //       response.config.url.includes(
            //         'afterSaleChangeReqNewFlightDetail'
            //       )
            //     ) {
            //       requestMergeCode('afterSaleChangeReqNewFlightDetail', [
            //         require('../utils/apiAppeaOldMessgae/afterSaleChangeReqNewFlightDetail.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }
            //   if (/(ApplySubmit)/.test(window.location.href)) {
            //     let apiname = '';
            //     if (response.config.url.includes('afterSaleChangeReqPayOK'))
            //       apiname = 'afterSaleChangeReqPayOK';
            //     if (response.config.url.includes('afterSaleVolChangeReqPayOK'))
            //       apiname = 'afterSaleVolChangeReqPayOK';
            //     if (response.config.url.includes('touchConfirmIntVol'))
            //       apiname = 'touchConfirmIntVol';
            //     if (
            //       /(afterSaleChangeReqPayOK)|(afterSaleVolChangeReqPayOK)|(touchConfirmIntVol)/.test(
            //         response.config.url
            //       )
            //     ) {
            //       requestMergeCode(apiname, [
            //         require('../utils/apiAppeaOldMessgae/change.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }
            // }

            // if (window.sessionStorage.getItem('atSwitch') == 'Y') {
            //   let type = window.sessionStorage.getItem('scopeType');
            //   if (/(updateDetail)/.test(window.location.href)) {
            //     if (response.config.url.includes('checkOrderTicket')) {
            //       requestMergeCode('checkOrderTicket', [
            //         type
            //           ? type.includes('bg')
            //             ? require('../utils/apiArtiNewMessage/checkOrderTicket.change.json')
            //             : require('../utils/apiArtiNewMessage/checkOrderTicket.refund.json')
            //           : require('../utils/apiArtiNewMessage/checkOrderTicket.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }
            //   if (/(changeRefundExplain)/.test(window.location.href)) {
            //     if (response.config.url.includes('checkOrderTicketTPWL')) {
            //       requestMergeCode('checkOrderTicketTPWL', [
            //         require('../utils/apiArtiNewMessage/checkOrderTicket.tpwl.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }
            //   if (/(cancelLation)/.test(window.location.href)) {
            //     if (response.config.url.includes('checkOrderTicketTPWL')) {
            //       requestMergeCode('checkOrderTicketTPWL', [
            //         require('../utils/apiArtiNewMessage/checkOrderTicket.tpwl.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }

            //   if (/(EndorsedApply)/.test(window.location.href)) {
            //     let selectStyle = '';
            //     if (/(ticketChange)/.test(window.location.href))
            //       selectStyle = 'change';
            //     if (/(refundTicket)/.test(window.location.href))
            //       selectStyle = 'refund';
            //     if (/(TPWL)/.test(window.location.href)) selectStyle = 'tpwl';

            //     if (response.config.url.includes('checkTicketFlight')) {
            //       if (selectStyle === 'refund') {
            //         requestMergeCode('checkTicketFlight', [
            //           require('../utils/apiArtiNewMessage/checkTicketFlight.refund.json'),
            //         ]);
            //       }
            //       if (selectStyle === 'change') {
            //         requestMergeCode('checkTicketFlight', [
            //           require('../utils/apiArtiNewMessage/checkTicketFlight.change.json'),
            //         ]);
            //       }
            //       if (selectStyle === 'tpwl') {
            //         requestMergeCode('checkTicketFlightTPWL', [
            //           require('../utils/apiArtiNewMessage/checkTicketFlight.tpwl.json'),
            //         ]);
            //       }
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }

            //     if (response.config.url.includes('checkOrderTicket')) {
            //       if (selectStyle === 'refund') {
            //         requestMergeCode('checkOrderTicket', [
            //           require('../utils/apiArtiNewMessage/checkOrderTicket.refund.json'),
            //         ]);
            //       }
            //       if (selectStyle === 'change') {
            //         requestMergeCode('checkOrderTicket', [
            //           require('../utils/apiArtiNewMessage/checkOrderTicket.change.json'),
            //         ]);
            //       }
            //       if (selectStyle === 'tpwl') {
            //         requestMergeCode('checkOrderTicketTPWL', [
            //           require('../utils/apiArtiNewMessage/checkOrderTicket.tpwl.json'),
            //         ]);
            //       }
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }
            //   if (/(refundApply)/.test(window.location.href)) {
            //     if (response.config.url.includes('afterSaleRefundApp')) {
            //       requestMergeCode('afterSaleRefundApp', [
            //         require('../utils/apiArtiNewMessage/createRefund.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }

            //     if (response.config.url.includes('submitFastRefundMultiple')) {
            //       requestMergeCode('submitFastRefundMultiple', [
            //         require('../utils/apiArtiNewMessage/submitFastRefundMultiple.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }
            //   if (/(selectDate)/.test(window.location.href)) {
            //     if (response.config.url.includes('checkFlightDate')) {
            //       requestMergeCode('checkFlightDate', [
            //         require('../utils/apiArtiNewMessage/checkFlightDate.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }
            //   if (/(TicketChange)/.test(window.location.href)) {
            //     if (response.config.url.includes('checkFlightDate')) {
            //       requestMergeCode('checkFlightDate', [
            //         require('../utils/apiArtiNewMessage/checkFlightDate.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //     if (
            //       response.config.url.includes(
            //         'afterSaleChangeReqNewFlightDetail'
            //       )
            //     ) {
            //       requestMergeCode('afterSaleChangeReqNewFlightDetail', [
            //         require('../utils/apiArtiNewMessage/afterSaleChangeReqNewFlightDetail.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }
            //   if (/(ApplySubmit)/.test(window.location.href)) {
            //     let apiname = '';
            //     if (response.config.url.includes('afterSaleChangeReqPayOK'))
            //       apiname = 'afterSaleChangeReqPayOK';
            //     if (response.config.url.includes('afterSaleVolChangeReqPayOK'))
            //       apiname = 'afterSaleVolChangeReqPayOK';
            //     if (response.config.url.includes('touchConfirmIntVol'))
            //       apiname = 'touchConfirmIntVol';
            //     if (
            //       /(afterSaleChangeReqPayOK)|(afterSaleVolChangeReqPayOK)|(touchConfirmIntVol)/.test(
            //         response.config.url
            //       )
            //     ) {
            //       requestMergeCode(apiname, [
            //         require('../utils/apiArtiNewMessage/change.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }
            // } else {
            //   let type = window.sessionStorage.getItem('scopeType');
            //   if (/(updateDetail)/.test(window.location.href)) {
            //     if (response.config.url.includes('checkOrderTicket')) {
            //       requestMergeCode('checkOrderTicket', [
            //         type
            //           ? type.includes('bg')
            //             ? require('../utils/apiOldMessage/checkOrderTicket.change.json')
            //             : require('../utils/apiOldMessage/checkOrderTicket.refund.json')
            //           : require('../utils/apiOldMessage/checkOrderTicket.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }
            //   if (/(cancelLation)/.test(window.location.href)) {
            //     if (response.config.url.includes('checkOrderTicketTPWL')) {
            //       requestMergeCode('checkOrderTicketTPWL', [
            //         require('../utils/apiOldMessage/checkOrderTicket.tpwl.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }

            //   if (/(EndorsedApply)/.test(window.location.href)) {
            //     let selectStyle = '';
            //     if (/(ticketChange)/.test(window.location.href))
            //       selectStyle = 'change';
            //     if (/(refundTicket)/.test(window.location.href))
            //       selectStyle = 'refund';
            //     if (/(TPWL)/.test(window.location.href)) selectStyle = 'tpwl';

            //     if (response.config.url.includes('checkTicketFlight')) {
            //       if (selectStyle === 'refund') {
            //         requestMergeCode('checkTicketFlight', [
            //           require('../utils/apiOldMessage/checkTicketFlight.refund.json'),
            //         ]);
            //       }
            //       if (selectStyle === 'change') {
            //         requestMergeCode('checkTicketFlight', [
            //           require('../utils/apiOldMessage/checkTicketFlight.change.json'),
            //         ]);
            //       }
            //       if (selectStyle === 'tpwl') {
            //         requestMergeCode('checkTicketFlightTPWL', [
            //           require('../utils/apiOldMessage/checkTicketFlight.tpwl.json'),
            //         ]);
            //       }
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }

            //     if (response.config.url.includes('checkOrderTicket')) {
            //       if (selectStyle === 'refund') {
            //         requestMergeCode('checkOrderTicket', [
            //           require('../utils/apiOldMessage/checkOrderTicket.refund.json'),
            //         ]);
            //       }
            //       if (selectStyle === 'change') {
            //         requestMergeCode('checkOrderTicket', [
            //           require('../utils/apiOldMessage/checkOrderTicket.change.json'),
            //         ]);
            //       }
            //       if (selectStyle === 'tpwl') {
            //         requestMergeCode('checkOrderTicketTPWL', [
            //           require('../utils/apiOldMessage/checkOrderTicket.tpwl.json'),
            //         ]);
            //       }
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }
            //   if (/(refundApply)/.test(window.location.href)) {
            //     if (response.config.url.includes('submitFastRefundMultiple')) {
            //       requestMergeCode('submitFastRefundMultiple', [
            //         require('../utils/apiOldMessage/submitFastRefundMultiple.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }

            //   if (/(TicketChange)/.test(window.location.href)) {
            //     if (
            //       response.config.url.includes(
            //         'afterSaleChangeReqNewFlightDetail'
            //       )
            //     ) {
            //       requestMergeCode('afterSaleChangeReqNewFlightDetail', [
            //         require('../utils/apiOldMessage/afterSaleChangeReqNewFlightDetail.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }
            //   if (/(ApplySubmit)/.test(window.location.href)) {
            //     let apiname = '';
            //     if (response.config.url.includes('afterSaleChangeReqPayOK'))
            //       apiname = 'afterSaleChangeReqPayOK';
            //     if (response.config.url.includes('afterSaleVolChangeReqPayOK'))
            //       apiname = 'afterSaleVolChangeReqPayOK';
            //     if (response.config.url.includes('touchConfirmIntVol'))
            //       apiname = 'touchConfirmIntVol';
            //     if (
            //       /(afterSaleChangeReqPayOK)|(afterSaleVolChangeReqPayOK)|(touchConfirmIntVol)/.test(
            //         response.config.url
            //       )
            //     ) {
            //       requestMergeCode(apiname, [
            //         require('../utils/apiOldMessage/change.json'),
            //       ]);
            //       response.data = setResponseMsg2(
            //         response.data,
            //         response.config
            //       );
            //     }
            //   }
            // }
            response.data = setResponseMsg3(response.data, response.config);
            return response;
          },
          error(error) {
            Toast.hide();
            if (document.getElementById('wrapper')) {
              document
                .getElementById('wrapper')
                .setAttribute('aria-hidden', 'false');
            }
            if (error.errorCode) {
              switch (error.errorCode) {
                case 9998:
                  if (isEN) {
                    TicPopUp(en.reminder1, en.timeOut);
                  } else {
                    TicPopUp('温馨提示', '网络超时');
                  }
                  break;
                case 9999:
                  if (!error.response || error.response.status !== 999) {
                    if (
                      error.response.status === 504 &&
                      (error.response.config.url.includes(
                        'afterSaleVolChangeReqPayOK'
                      ) ||
                        error.response.config.url.includes(
                          'afterSaleChangeReqPayOK'
                        ) ||
                        error.response.config.url.includes(
                          'afterSaleRefundApp'
                        ) ||
                        error.response.config.url.includes('createRefundTa') ||
                        error.response.config.url.includes('createGPChange') ||
                        error.response.config.url.includes('createE2EChange') ||
                        error.response.config.url.includes('createE2ERefund'))
                    ) {
                      ProgressBar.clear();
                      let isAIComming = window.sessionStorage.getItem(
                        'isAIComming'
                      );
                      let isAICommingFT = window.sessionStorage.getItem(
                        'isAICommingFT'
                      );
                      let enterUrl = window.sessionStorage.getItem('enterUrl')
                        ? window.sessionStorage.getItem('enterUrl')
                        : process.env.REACT_APP_APP +
                          'ticketRefund/#/ticket/updateDetail?' +
                          (isAIComming
                            ? 'channel=AI&from=assistant'
                            : isAICommingFT
                            ? 'channel=AI'
                            : '');
                      let tip =
                        error.response.config.url.includes(
                          'afterSaleVolChangeReqPayOK'
                        ) ||
                        error.response.config.url.includes(
                          'afterSaleChangeReqPayOK'
                        ) ||
                        error.response.config.url.includes('createGPChange') ||
                        error.response.config.url.includes('createE2EChange')
                          ? isEN
                            ? en.Processing2
                            : '您的变更申请已提交，请稍后在“处理中”或“已退改”列表中查看详情或完成支付。若无法查询到相关变更申请，请重新提交变更，谢谢。'
                          : isEN
                          ? en.Processing3
                          : '您的退票申请已提交，稍后请在“处理中”或“已退改”模块查看。若您无法查询到您的退票申请，请重新点击“退票”按钮申请客票退票，谢谢。';
                      if (!window.sessionStorage.getItem('进度条')) {
                        console.log(window.location.href, '超时地址');
                        TicPopUp(
                          isEN ? en.reminder1 : '温馨提示',
                          tip,
                          () => {
                            if (
                              window.location.href.includes('refundApply') &&
                              window.location.href.includes('channel=AI')
                            ) {
                              window.location.href =
                                process.env.REACT_APP_APP +
                                'ticketRefund/#/ticket/updateDetail?';
                              return;
                            }
                            window.location.href = enterUrl;
                          },
                          '',
                          [
                            {
                              text: isEN ? en.refCupon33 : '确认',
                              onPress: () => {
                                if (
                                  window.location.href.includes(
                                    'refundApply'
                                  ) &&
                                  window.location.href.includes('channel=AI')
                                ) {
                                  window.location.href =
                                    process.env.REACT_APP_APP +
                                    'ticketRefund/#/ticket/updateDetail?';
                                  return;
                                }
                                window.location.href = enterUrl;
                              },
                            },
                          ],
                          '3.85rem'
                        );
                      }
                    } else {
                      if (isEN) {
                        TicPopUp(en.reminder1, en.yichang);
                      } else {
                        TicPopUp('温馨提示', '网络异常');
                      }
                    }
                  }
                  break;
                default:
                  break;
              }
            }

            if (error.response) {
              // 系统异常，进入预约流程
              if (
                error.response.status >= 500 &&
                error.response.status < 999 &&
                JSON.parse(
                  JSON.parse(window.sessionStorage.getItem('persist:emp')).App
                )['sysConfig']['the_flag_fastchange']
              ) {
                jumpPage();
              }
              // 用户权限失效，登录操作
              if (error.response.status === 999) {
                loginPop(readConfig);
                return error;
              }
            }
            return error;
          },
        },
      ],
    },
  }
);

export default function axiosMiddleware({ dispatch, getState }) {
  return next => action => {
    // 是否是axios规范action
    if (!isAxiosRequest(action)) {
      return next(action);
    }

    const {
      type,
      closeLoading,
      payload: { request },
      cache,
    } = action;

    const options = {
      config: request,
      loading: !closeLoading,
    };
    if (cache) options.cache = cache;

    next({ ...action, type }); // 请求前action

    return client.createHttp(request.method, request.url, options).then(
      response => {
        const newAction = {
          type: `${action.type}_SUCCESS`,
          payload: response,
          meta: {
            previousAction: action,
          },
        };

        // 防止该中间件向下响应导致报错
        if (
          response.errorCode &&
          (response.errorCode === 9999 || response.errorCode === 9998)
        ) {
          newAction.payload = response.response || { data: {} };
        }

        next(newAction);
        return newAction;
      },
      error => {
        const nextAction = {
          type: `${action.type}_FAIL`,
          error,
          meta: {
            previousAction: action,
          },
        };
        if (error.errorCode === 9999 && error.response.status === 999) {
          return error;
        }
        next(nextAction);
        return nextAction;
      }
    );
  };
}



// WEBPACK FOOTER //
// ./src/store/axiosMiddleware.js